export default __webpack_public_path__ + "static/media/logo_white.ff3473ba.svg";